import { endpoints } from 'api/endpoints'
import { GetArrayResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { PromoPeriod, PromoPeriodBase } from 'interfaces/api/promoPeriods.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<PromoPeriod> => {
  const { data: response } = await axios.request<PromoPeriod[]>({
    method: 'GET',
    url: endpoints.promoPeriods.getAll(),
  })
  return response
}

const create = async (data: PromoPeriodBase): GetOneResponse<PromoPeriod> => {
  const { data: response } = await axios.request<PromoPeriod>({
    method: 'POST',
    url: endpoints.promoPeriods.create(),
    data,
  })
  return response
}

const update = async (id: number, data: PromoPeriodBase): GetOneResponse<PromoPeriod> => {
  const { data: response } = await axios.request<PromoPeriod>({
    method: 'PATCH',
    url: endpoints.promoPeriods.update(id),
    data,
  })
  return response
}

const remove = (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.promoPeriods.remove(id),
  })

export const promoPeriodsApi = {
  create,
  getAll,
  update,
  remove,
}
